export const CAR_NEWS_RSS_FEED_URL = 'https://www.edmunds.com/feeds/rss/car-news.xml';
